// extracted by mini-css-extract-plugin
export default {"Stage":"stage_Stage__6ZgIP"};